<template>
    <div class="hired">
        <Navbar />
        <div class="mt-5 pt-5 kovatek-width">
            <div class="px-0 mx-3 px-sm-2 mx-sm-3 px-md-3 mx-md-3 px-lg-4 mx-lg-4 mt-4">
                <div class="text-left mt-3 ml-5 mb-4"><a-icon class="mr-1" type="arrow-left" /> <span class="go-back" @click="goBack">Go Back</span></div>
            </div>
            <div v-if="loading" class="page-loader">
                <hollow-dots-spinner
                    :animation-duration="1000"
                    :dot-size="15"
                    :dots-num="3"
                    color="#20409a"
                />
            </div>
            <div v-else class="container-fluid">
                <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-8 pl-md-5 pr-md-4">
                    <div class="mt-5">
                        <a-tabs defaultActiveKey="2">
                            <a-tab-pane tab="Details" key="1">
                                <div class="bg-light border add-rounded p-4 mt-4">
                                    <div class="row">
                                        <div class="col-12 col-sm-12 col-md-9">
                                            <div class="row pl-3">
                                                <div><h5 class="font-weight-bolder text-left">{{project.Title}}</h5></div>
                                                <a-tooltip placement="topLeft">
                                                    <template slot="title">
                                                        <span><a-icon class="mr-2" type="info-circle" style="position:relative; bottom: 3px;font-size: 16px;"/>click to copy</span>
                                                    </template>
                                                    <span class="ml-2">
                                                        <div class="kova-id ml-3 text-white px-2 pointer" style="height: 20px">ID: {{project.ID}}</div>
                                                    </span>
                                                </a-tooltip>
                                                    </div>
                                            <h5 class="text-left mt-3">Brief</h5>
                                            <p class="text-left" v-html="project.Description">
                                                <!-- Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
                                                eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
                                                voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita
                                                kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.
                                                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
                                                eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam -->
                                                <!-- {{project.Description}} -->
                                            </p>
                                            <h5 class="text-left mt-3">Skills Required</h5>
                                            <div class="text-left d-flex flex-wrap">
                                                <span class="bg-skills px-3 py-2 mr-3 mb-3 rounded ctrl-size-2 pointer"  v-for="skill in project.Skills" :key="skill">
                                                    {{skill}}</span>
                                            </div>
                                            <h5 class="text-left mt-3">Budget</h5>
                                            <div class="row pl-3">
                                                <div><h4 class="text-left font-weight-bolder"><!-- ${{project.StartBudget}} - ${{project.EndBudget}} --> <!-- <small v-if="project.Currency == 'USD'">USD</small> <small v-else-if="project.Currency == 'NGN'">NGN</small> -->{{ project.Budget}} <small>{{ project.Currency}} / month</small> </h4></div>
                                                <!-- <div class="ml-3 mt-2 incr-font-2 font-italic mb-3 mt-0">$20.00/hr</div> -->
                                                
                                                    <!-- <button class="btn-kovatek shadow py-2 px-3 px-md-4 btn-rounded ml-4 ml-md-5 pl-md-4">Enter Project Board</button> -->
                                            </div>
                                            <div class="mt-3">
                                            
                                               <!--  <p class="ant-color text-left pointer" v-if="showmore" @click="showOtherDetails">View More Details<a-icon class="ml-2" type="double-right" :rotate="90" /></p> -->
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-12 col-md-3">
                                            <div class="d-flex">
                                                <div class="text-right font-weight-bolder"><font-awesome-icon icon="clock" class="mr-2"/>{{projectStatus}}</div>
                                                <a-dropdown placement="bottomRight">
                                                    <a-icon class="ctrl-ellipsis font-weight-bolder" :rotate="90" type="ellipsis" />
                                                    <a class="ant-dropdown-link kova-text adjust-icon" href="#"> </a>
                                                    <a-menu class="px-4" slot="overlay">
                                                    <a-menu-item class="kova-text font-weight-bolder mt-3" key="1">
                                                        <!-- <router-link class="kova-text" to="/onboarding-review"> -->
                                                            <span class="kova-text" @click="editJob">Edit Job </span>
                                                        <!-- </router-link> -->
                                                    </a-menu-item>
                                                    <a-divider class="my-3 px-1"/>
                                                    <a-menu-item class="kova-text font-weight-bolder" key="2"><span class="kova-text" @click="updateProjectStatus(2)">Open for new Bidders</span></a-menu-item>
                                                    <a-divider class="my-3 px-1"/>
                                                    <a-menu-item class="kova-text font-weight-bolder" key="3"><span class="kova-text" @click="updateProjectStatus(3)">Close for Bidding</span></a-menu-item>
                                                    <a-divider class="my-3 px-1"/>
                                                    <a-menu-item class="kova-text font-weight-bolder" key="4"><span class="kova-text" @click="updateProjectStatus(4)">Project Ongoing</span></a-menu-item>
                                                    <a-divider class="my-3 px-1"/>
                                                    <a-menu-item class="kova-text font-weight-bolder" key="4"><span class="kova-text" @click="updateProjectStatus(5)">Archive Project</span></a-menu-item>
                                                    <a-divider class="my-3 px-1"/>
                                                    <a-menu-item class="kova-text font-weight-bolder" key="4"><span class="kova-text" @click="updateProjectStatus(6)">Project Completed</span></a-menu-item>
                                                    <a-divider class="my-3 px-1"/>
                                                    <a-menu-item class="kova-text font-weight-bolder mb-3" key="5"><span class="kova-text" @click="showModal">Delete Project</span></a-menu-item>
                                                    </a-menu>
                                                </a-dropdown>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pt-3" v-if="otherDetails">
                                        <hr>
                                        <div class="row mt-2 text-left">
                                            <div class="col-4 mt-2">
                                                <h6 class="font-weight-bolder ctrl-size-4">UI/UX Prototype</h6>
                                                <p class="ctrl-size-2">Project Specification</p>
                                            </div>
                                            <div class="col-4 mt-2">
                                                <h6 class="font-weight-bolder ctrl-size-4">{{projectCommitment}}</h6>
                                                <p class="ctrl-size-2">Hours needed</p>
                                            </div>
                                            <div class="col-4 mt-2">
                                                <h6 class="font-weight-bolder ctrl-size-4">{{projectDuration}}</h6>
                                                <p class="ctrl-size-2">Project Timeline</p>
                                            </div>
                                            <div class="col-4 mt-2">
                                                <h6 class="font-weight-bolder ctrl-size-4">{{project.Talents.length}} of {{project.TalentSize}} Hired</h6>
                                                <p class="ctrl-size-2">Developers to hire</p>
                                            </div>
                                            <div class="col-4 mt-2">
                                                <h6 class="font-weight-bolder ctrl-size-4"><font-awesome-icon style="font-size: 14px;" icon="map-marker-alt" class="text-dark mr-1"></font-awesome-icon>{{project.City}}, {{project.Country}}</h6>
                                                <p class="ctrl-size ml-3">Location</p>
                                            </div>
                                            <div class="col-4 mt-2">
                                                <h6 class="font-weight-bolder ctrl-size-4">Interviewing: 6</h6>
                                                <p class="ctrl-size-2">Interview</p>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="">
                                            <h5 class="text-left">Specialization</h5>
                                            <div class="text-left d-flex flex-wrap">
                                                <span class="bg-skills px-3 py-2 mr-3 mb-3 rounded ctrl-size-2 mt-2"  v-for="specialization in project.Specializations" :key="specialization">
                                                    {{specialization}}</span>
                                            </div>
                                        </div>
                                        <div class="">
                                            <h5 class="text-left">Attached Files</h5>
                                            <div class="text-left d-flex flex-wrap">
                                                <button class="btn-kovatek py-2 px-2 add-rounded" disabled> <a-icon type="upload" /> Not available </button>
                                            </div>
                                        </div>
                                       <!--  <p class="ant-color text-left mt-3 pointer" @click="showLessDetails">Show Less <a-icon class="ml-2" type="double-right" :rotate="-90" /></p> -->
                                    </div>
                                </div>

                                <!-- cover letter downwards -->
                                <!-- <div class="mb-5">
                                    <h4 class="text-left mt-4">Cover Letter</h4>
                                    <a-textarea class="px-3 py-3 mb-3" placeholder="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod temporinvidunt ut labore et dolore magna aliquyam erat, sed diam voluptua." :rows="4" />
                                    <div class="row">
                                        <div class="col-12 col-md-6">
                                            <h5 class="text-left mt-4 ml-3">Bill Amount</h5>
                                            <a-input-group compact>
                                                <a-input size="large" class="text-left" style="width: 70%" placeholder="2000" />
                                                <a-select size="large" class="text-left" defaultValue="USD">
                                                    <a-select-option value="USD">USD</a-select-option>
                                                    <a-select-option value="Naira">Naira</a-select-option>
                                                    <a-select-option value="EUR">EUR</a-select-option>
                                                </a-select>
                                            </a-input-group>
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <h5 class="text-left mt-4 ml-3">Delivery Timeline in Days</h5>
                                            <a-input-group compact>
                                                <a-input size="large" class="text-left" style="width: 70%" placeholder="7" />
                                                <a-select size="large" class="text-left" defaultValue="Days">
                                                <a-select-option value="Days">Days</a-select-option>
                                                <a-select-option value="Weeks">Weeks</a-select-option>
                                                <a-select-option value="Months">Months</a-select-option>
                                            </a-select>
                                    </a-input-group>
                                        </div>
                                    </div>
                                    <div class="mt-4">
                                        <h5 class="text-left mt-3 ml-3 pl-2">Milestone</h5>
                                        <div :key="mile" v-for="mile in mileStone" class="text-left ml-4">
                                            <a-input-group compact class="mt-3 font-weight-bolder">
                                                <a-input size="large" :value="mile.title" class="text-left mr-3 font-weight-bold" style="width: 50%" :placeholder="mile.title" />
                                                <a-input size="large" :value="mile.amount" class="text-left font-weight-bold" style="width: 15%" :placeholder="mile.amount" />
                                                <a-select size="large" class="text-left" defaultValue="USD">
                                                    <a-select-option value="USD">USD</a-select-option>
                                                        <a-select-option value="Naira">Naira</a-select-option>
                                                    <a-select-option value="EUR">EUR</a-select-option>
                                            </a-select>
                                        </a-input-group>
                                            <div class="text-left mt-3 pb-2 pl-sm-3 ml-3"><span class="bg-light p-2 rounded">Monday, 20th of January, 2020</span> <a-icon class="ml-1" type="edit" /></div>
                                        </div>
                                    </div>
                                </div> -->
                                <hr class="my-4"/>

                            </a-tab-pane>
                            <a-tab-pane tab="Applicants" key="2" forceRender>
                                <div class="my-4">
                                    <div class="p-4 bg-light border shadow-sm add-rounded">
                                        <div :key="applicant" v-for="applicant in applicants">
                                            <div class="row">
                                            <div class="class col-3 col-sm-3 col-md-2 pl-1">
                                                <img src="../assets/kovatek/Mask Group 46.svg" alt="" class="rounded-circle img-height" />
                                            </div>
                                            <div class="col-9 col-sm-9 col-md-7 text-left">
                                                <h5 class="font-weight-bolder kova-text">{{applicant.Profile.Setting.Firstname}} {{applicant.Profile.Setting.Surname}}
                                                    <img class="ml-1 ml-md-2 mb-1" style="height:22px;" src="../assets/kovatek/correct.svg" alt="" />
                                                    <span class="ml-3"><img class="mr-1 rating" src="../assets/kovatek/best.svg" alt="" /><span class="font-weight-bolder ctrl-size-1 kova-green">{{applicant.Profile.SkillScore}}</span><span class="ml-2 ctrl-size-2 kova-light">{{applicant.Profile.Reviews}} reviews</span></span>
                                                </h5>
                                                <p><span class="font-italic">{{applicant.Profile.Speciality}}</span> <span class="ml-3 text-uppercase intermediate ctrl-size-2"> {{ computeLevel(applicant.Profile.SeniorityLevel) }} </span><span class="font-weight-bolder ctrl-size-5 ml-3"><font-awesome-icon style="font-size: 14px;" icon="map-marker-alt" class="text-dark mr-1"></font-awesome-icon>{{applicant.Profile.City}}, {{applicant.Profile.Country}}</span> </p>
                                                <p class="text-size2" v-html="applicant.Profile.AboutMe">
                                                
                                                </p>
                                                <div class="text-left d-flex flex-wrap">
                                                    
                                                    <span class="bg-skills px-3 py-2 mr-3 mb-3 rounded ctrl-size-2"  v-for="skill in mergeSkills(applicant.Profile.CoreTechstack, applicant.Profile.OtherCoreTechstacks)" :key="skill">
                                                        {{skill}}</span>
                                                       
                                                </div>
                                               <!--  <div v-if="!work.readMore" class="text-left d-flex flex-wrap">
                                                    <span class="bg-skills px-3 py-2 mr-3 mb-3 rounded ctrl-size-2 "  v-for="skill in proSkills" :key="skill">
                                                        {{skill}}</span>
                                                      
                                                </div> -->
                                            </div>
                                            <div class="pl-4 pl-sm-5 pl-md-3 mt-3 mt-md-0 col-12 col-sm-12 col-md-3 text-right">
                                                <div class="float-text">
                                                    <h6 class="font-weight-bolder kova-light ctrl-size-4">Project completed: {{applicant.Profile.ProjectsCompleted}}</h6>
                                                    <h6 class="font-weight-bolder kova-light ctrl-size-4">Team Work: 4</h6>
                                                    <!-- <h5 class="font-weight-bolder kova-text mt-lg-3">$90</h5> -->
                                                </div>

                                                <div class="d-flex mt-md-5 pt-3">
                                                    <div class="mr-auto"></div>
                                                    <span class="btn-hired py-2 px-3 ctrl-size-2 btn-rounded" v-if="applicant.Profile.CurrentlyHired" style="white-space:nowrap">Currently Hired</span>
                                                   <!--  <flutterwave-pay-button
                                                            :tx_ref="generateReference()"
                                                            :amount=20
                                                            currency='NGN'
                                                            payment_options="card,ussd"
                                                            redirect_url=""
                                                            class="btn-kovatek"
                                                            style=""
                                                            :meta="{counsumer_id: '7898' ,consumer_mac: 'kjs9s8ss7dd' }"
                                                            :customer="{ name: 'Demo Customer  Name',
                                                            email: 'customer@mail.com', 
                                                            phone_number: '0818450****' }"
                                                            :customizations="{  title: 'Customization Title' ,
                                                            description: 'Customization Description'  ,
                                                            logo : 'https://flutterwave.com/images/logo-colored.svg' }"
                                                            :callback="makePaymentCallback"
                                                            :onclose="closedPaymentModal"
                                                        >   Click To Pay </flutterwave-pay-button> -->
                                                    <span class="btn-kovatek py-2 px-3 ctrl-size-2 btn-rounded" v-if="applicant.Status == 0" style="white-space:nowrap" @click="showHire(applicant.UserID, project.Budget)">Hire For Job</span>
                                                    <span class="btn-kovatek py-2 px-3 ctrl-size-2 btn-rounded" v-if="applicant.Status !== 0" style="white-space:nowrap; background:#FE9816; border: 1px solid #FE9816" >Hired</span>
                                                    <font-awesome-icon v-if="!applicant.Profile.SavedProjects" :icon="['far', 'bookmark']" class="bookmark ml-3 mt-1 kova-light pointer" @click="devDetails" ></font-awesome-icon>
                                                    <font-awesome-icon v-if="applicant.Profile.SavedProjects" :icon="['fas', 'bookmark']" class="bookmark ml-3 mt-1 kova-light pointer" @click="devDetails" style="color: #FE9816"></font-awesome-icon>
                                                </div>
                                                <!-- <div  class="d-flex mt-md-5 pt-3 justify-content-end">
                                                    <font-awesome-icon v-if="!applicant.Profile.SavedProjects" :icon="['far', 'bookmark']" class="bookmark ml-3 mt-1 kova-light pointer" @click="devDetails"></font-awesome-icon>
                                                    <font-awesome-icon v-if="applicant.Profile.SavedProjects" :icon="['fas', 'bookmark']" class="bookmark ml-3 mt-1 kova-light pointer" @click="devDetails" style="color: #FE9816"></font-awesome-icon>
                                                </div>
                                                <div  class="d-flex mt-3 justify-content-end">
                                                    <span class="btn-kovatek py-2 px-2 btn-rounded ctrl-size-2" style="white-space:nowrap" @click="message">Send Direct Message</span>
                                                </div> -->
                                            </div>
                                            <div class="col-12">
                                               <!--  <div class="mt-4" v-show="work.readMore">
                                                    <div class="row ml-lg-4">
                                                        <div class="col-12 col-md-6">
                                                            <h5 class="text-left mt-4 ml-3 ctrl-size-4">Bill Amount</h5>
                                                            <a-input-group compact>
                                                                <a-input class="text-left" style="width: 70%" placeholder="2000" />
                                                                <a-select class="text-left" defaultValue="USD">
                                                                    <a-select-option value="USD">USD</a-select-option>
                                                                    <a-select-option value="Naira">Naira</a-select-option>
                                                                    <a-select-option value="EUR">EUR</a-select-option>
                                                                </a-select>
                                                            </a-input-group>
                                                        </div>
                                                        <div class="col-12 col-md-6">
                                                            <h5 class="text-left mt-4 ml-3 ctrl-size-4">Delivery Timeline in Days</h5>
                                                            <a-input-group compact>
                                                                <a-input class="text-left" style="width: 70%" placeholder="7" />
                                                                <a-select class="text-left" defaultValue="Days">
                                                                <a-select-option value="Days">Days</a-select-option>
                                                                <a-select-option value="Weeks">Weeks</a-select-option>
                                                                <a-select-option value="Months">Months</a-select-option>
                                                            </a-select>
                                                    </a-input-group>
                                                        </div>
                                                    </div>
                                                    <div class="mt-4 ml-lg-4">
                                                        <h5 class="text-left mt-3 ml-3 pl-2 ctrl-size-4">Milestone</h5>
                                                        <div :key="mile" v-for="mile in mileStone" class="text-left ml-4">
                                                            <a-input-group compact class="mt-3 font-weight-bolder">
                                                                <a-input :value="mile.title" class="text-left mr-3 font-weight-bold ctrl-size-4" style="width: 50%" :placeholder="mile.title" />
                                                                <a-input :value="mile.amount" class="text-left font-weight-bold" style="width: 15%" :placeholder="mile.amount" />
                                                                <a-select class="text-left" defaultValue="USD">
                                                                    <a-select-option value="USD">USD</a-select-option>
                                                                        <a-select-option value="Naira">Naira</a-select-option>
                                                                    <a-select-option value="EUR">EUR</a-select-option>
                                                            </a-select>
                                                        </a-input-group>
                                                            <div class="text-left mt-2 pb-2 pl-sm-3 ml-3 ml-sm-4 pl-md-4 ml-lg-5 pl-lg-5"><span class="px-2 py-1 rounded ctrl-size-2" style="background-color: #efefef">Monday, 20th of January, 2020</span></div>
                                                        </div>
                                                    </div>
                                                    <div class="text-left d-flex">
                                                        <span class="ant-color pointer mr-auto ml-lg-5" @click="work.readMore = !work.readMore" v-if="work.readMore">See less</span>
                                                        <span class="btn-hired py-2 px-3 ctrl-size-2 btn-rounded ml-3 mr-md-5" v-if="work.hireStatus" style="white-space:nowrap">Currently Hired</span>
                                                        <span class="btn-kovatek py-2 px-3 ctrl-size-2 btn-rounded mr-md-5" v-if="!work.hireStatus" style="white-space:nowrap" @click="showHire(talentid, wages)">Hire For Job</span>
                                                    </div>
                                                </div> -->
                                            </div>
                                        </div>
                                        <hr>
                                        </div>
                                        
                                    </div>
                                </div>
                            </a-tab-pane>
                           <!--  <a-tab-pane tab="Job Delivered" key="3" forceRender>
                                <div class="mt-4 mb-5">
                                        <h5 class="font-weight-bolder text-left">Job Delivered</h5>
                                    <div class="px-0 px-md-4" :key="i" v-for="(mile, i) in mileStone">
                                        <div class="row">
                                            <div class="col-12 col-md-8">
                                                <a-input size="large" :value="mile.title" class="text-left mr-3 font-weight-bold change-size mt-3" :placeholder="mile.title" />
                                                <div class="d-flex flex-wrap">
                                                    <div class="text-left mt-3 pb-2 pl-sm-3 change-size"><span class="bg-light p-2 rounded">Monday, 20th of January, 2020</span> <a-icon class="ml-1" type="edit" /></div>
                                                    <div class="mt-3 ml-3">
                                                        <label class="checkbox-label">
                                                            <input type="checkbox" />
                                                            <span class="checkbox-custom rectangular"></span><span class="pl-4 ml-2 font-weight-bolder ctrl-size-4">Approve task</span>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="row mt-4 pl-3">
                                                    <div class="col-12 col-md-12 col-lg-6 text-left">
                                                        <span :href="'#files'+i" data-toggle="collapse"><span class="kova-text font-weight-bolder">Attached Files 
                                                        </span>
                                                        <a-icon :type="dir" /></span>
                                                        <div :id="'files'+i" class="collapse my-4">
                                                            <a-upload @change="upload"
                                                                action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                                                :defaultFileList="defaultFileList">
                                                            </a-upload>
                                                        </div>
                                                    </div>

                                                    <div class="col-12 col-md-12 col-lg-6 text-left">
                                                        <span :href="'#links'+i" data-toggle="collapse"><span class="kova-text font-weight-bolder"> Links 
                                                            </span>
                                                        <a-icon :type="dir" /></span>
                                                        <div :id="'links'+i" class="collapse my-4">
                                                            <p class="mt-2 mb-0 pb-0 light-blue text-left kova-text rounded py-1 px-3" :key="link" v-for="link in linkList"><a-icon type="link" style="font-size: 18px" class="mr-2" />{{link}}</p>
                                                        </div>
                                                    </div>

                                                    <div class="col-12 col-md-12 col-lg-12 text-left">
                                                        <span :href="'#chats'+i" data-toggle="collapse"><span class="kova-text font-weight-bolder"> Comments 
                                                            </span>
                                                        <a-icon :type="dir" /></span>
                                                        <div :id="'chats'+i" class="collapse my-4">
                                                            <div class="border rounded px-1 pt-3">
                                                                <div class="px-2">
                                                                    <div class="font-weight-bolder text-left ctrl-size-2">Adenuga Titus</div>
                                                                    <div class="text-left ctrl-size-2 mt-2">The quick, brown fox jumps over a lazy dog. DJs ﬂock by when MTV ax quiz prog. </div>
                                                                    <div class="text-left ctrl-size-3 mt-2">12 minutes ago</div>
                                                                    <hr />
                                                                    <div class="font-weight-bolder text-left ctrl-size-2">You</div>
                                                                    <div class="text-left ctrl-size-2 mt-2">The quick, brown fox jumps over a lazy dog. DJs ﬂock by when MTV ax quiz prog. </div>
                                                                    <div class="text-left ctrl-size-3 mt-2">12 minutes ago</div>
                                                                </div>
                                                                <template>
                                                                    <a-textarea placeholder="Your message here" :rows="3" class="mt-3"/>
                                                                </template>
                                                                <div class="row mt-3">
                                                                    <div class="col-6 kova-text text-left">
                                                                        <div class="row ml-3">
                                                                            <font-awesome-icon class="icon-1 pointer mt-1" icon="paperclip" style="font-size: 13px"></font-awesome-icon>
                                                                            <p class="font-weight-bolder ctrl-size-2 ml-1 pointer mt-1">Attach File</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-6 text-right">
                                                                        <span class="bg-dark rounded text-white ctrl-size-2 py-2 px-3 px-md-4">Reply</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-4 text-left">
                                                <a-input-group compact class="mt-3 mx-0 font-weight-bolder">
                                                    <a-input size="large" :value="mile.amount" class="text-left font-weight-bold change-size"  style="width: 50%" :placeholder="mile.amount" />
                                                    <a-select size="large" class="text-left change-size" defaultValue="USD">
                                                        <a-select-option value="USD">USD</a-select-option>
                                                            <a-select-option value="Naira">Naira</a-select-option>
                                                        <a-select-option value="EUR">EUR</a-select-option>
                                                    </a-select>
                                                </a-input-group>
                                                <div class="btn-kovatek text-white px-3 rounded py-2 mt-2 mx-lg-3 change-size" style="max-width:320px; white-space:nowrap" @click="paymentSummary">Release Fund</div>
                                            </div>
                                        </div>

                                         <div class="row mt-4">
                                            <div class="col-12 col-md-12 col-lg-6">
                                                <span :href="'#files'+i" data-toggle="collapse"><span class="kova-text font-weight-bolder">Attached Files 
                                                </span>
                                                <a-icon :type="dir" /></span>
                                                <div :id="'files'+i" class="collapse my-4">
                                                    <a-upload @change="upload"
                                                        action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                                        :defaultFileList="defaultFileList">
                                                        <span class="text-white bg-dark px-4 py-1 rounded"> Add Files <a-icon type="plus" style="position: relative; bottom: 3px"/> </span>
                                                    </a-upload>
                                                </div>
                                            </div>

                                            <div class="col-12 col-md-12 col-lg-6">
                                                <span :href="'#links'+i" data-toggle="collapse"><span class="kova-text font-weight-bolder"> Links 
                                                    </span>
                                                <a-icon :type="dir" /></span>
                                                <div :id="'links'+i" class="collapse my-4">
                                                    <span class="text-white bg-dark px-4 py-1 rounded mb-2" @click="openLink"> Add Link <a-icon type="plus" style="position: relative; bottom: 3px"/> </span>
                                                    <p class="mt-2 mb-0 pb-0 light-blue text-left kova-text rounded py-1 px-3" :key="link" v-for="link in linkList"><a-icon type="link" style="font-size: 18px" class="mr-2" />{{link}}</p>
                                                </div>
                                            </div>

                                            <div class="col-12 col-md-12 col-lg-6">
                                                <span :href="'#chats'+i" data-toggle="collapse"><span class="kova-text font-weight-bolder"> Comments 
                                                    </span>
                                                <a-icon :type="dir" /></span>
                                                <div :id="'chats'+i" class="collapse my-4">
                                                    <div class="border rounded px-1 pt-3">
                                                        <div class="px-2">
                                                            <div class="font-weight-bolder text-left ctrl-size-2">Adenuga Titus</div>
                                                            <div class="text-left ctrl-size-2 mt-2">The quick, brown fox jumps over a lazy dog. DJs ﬂock by when MTV ax quiz prog. </div>
                                                            <div class="text-left ctrl-size-3 mt-2">12 minutes ago</div>
                                                            <hr />
                                                            <div class="font-weight-bolder text-left ctrl-size-2">You</div>
                                                            <div class="text-left ctrl-size-2 mt-2">The quick, brown fox jumps over a lazy dog. DJs ﬂock by when MTV ax quiz prog. </div>
                                                            <div class="text-left ctrl-size-3 mt-2">12 minutes ago</div>
                                                        </div>
                                                        <template>
                                                            <a-textarea placeholder="Your message here" :rows="3" class="mt-3"/>
                                                        </template>
                                                        <div class="row mt-3">
                                                            <div class="col-6 kova-text text-left">
                                                                <div class="row ml-3">
                                                                    <font-awesome-icon class="icon-1 pointer mt-1" icon="paperclip" style="font-size: 13px"></font-awesome-icon>
                                                                    <p class="font-weight-bolder ctrl-size-2 ml-1 pointer mt-1">Attach File</p>
                                                                </div>
                                                            </div>
                                                            <div class="col-6 text-right">
                                                                <span class="bg-dark rounded text-white ctrl-size-2 py-2 px-3 px-md-4">Reply</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    
                                </div>
                            </a-tab-pane> -->
                        </a-tabs>
                    </div>
                    
                    
                </div>
                <div class="col-sm-12 col-md-12 col-lg-4 px-3 pl-lg-0 pr-lg-3">
                    <div class="pt-3 mt-2 pt-lg-4 mt-lg-5"></div>
                    <div class="pt-2 mt-1 pr-lg-5">
                    </div>
                    <div class="" style="position:sticky;top:80px;">
                        <CurrentlyHired />
                    </div>
                    <!-- <Notifications />
                    <Messages /> -->
                </div>
            </div>
            
            </div>

            <a-modal v-model="paymentModalVisible" title="Not enough balance in your wallet" :footer="null" @ok="handleOk">
            <flutterwave-pay-button
            :tx_ref="generateReference()"
            :amount= project.Budget
            :currency= project.Currency
            payment_options="card,ussd"
            redirect_url=""
            class="py-2 px-3 kova-bg text-white rounded font-weight-bolder ctrl-font pointer"
            style="white-space:nowrap; border: none;"
            :meta="{counsumer_id: '7898' ,consumer_mac: 'kjs9s8ss7dd' }"
            :customer="{ name: data.Firstname + data.Surname,
            email: data.Email, 
            phone_number: data.Phone }"
            :customizations="{  title: 'Kovatek Deposit' ,
            description: 'Customization Description'  ,
            logo : 'https://flutterwave.com/images/logo-colored.svg' }"
            :callback="makePaymentCallback"
            :onclose="closedPaymentModal"
            >   
            Click to Pay Directly </flutterwave-pay-button>
            </a-modal>

            
            <div class="">
                <a-modal v-model="hireVisible" onOk="handleOk" width="750px" centered>
                <template slot="footer">
                    <div class="d-flex">
                        <button key="back" @click="confirmHire" class="btn-kovatek add-rounded px-5 py-2 mr-auto">Yes</button>
                        <button key="submit" @click="cancelHire" class="btn-outline-kovatek add-rounded px-5 py-2">No</button>
                    </div>
                    
                </template>
                <div class="d-flex font-weight-bolder flex-wrap">
                    <span class="kova-text modal-text mt-md-4">Hire</span>
                    <div class="row bg-light py-3 add-rounded modal-row-width mx-auto">
                        <div class="col-3 pl-1 text-right">
                            <img src="../assets/kovatek/Mask Group 46.svg" alt="" class="rounded-circle img-height-1 " />
                        </div>
                        <div class="col-9 text-left">
                            <h5 class="font-weight-bolder kova-text mb-0 modal-name">Adebayo Mary
                                <img class="ml-1 ml-md-2 mb-1" style="height:22px;" src="../assets/kovatek/correct.svg" alt="" />
                            </h5>
                            <p><span class="font-italic">Web Developer</span> <span class="ml-sm-3 text-uppercase intermediate">intermediate</span> </p>
                        </div>
                    </div>
                    <span class="kova-text modal-text mt-md-4">For You Project?</span>
                </div>
                </a-modal>
            </div>
            <div class="">
                <a-modal v-model="visible" onOk="handleOk" width="750px" centered>
                <template slot="footer">
                    <div class="d-flex">
                        <button key="back" @click="deleteProject" class="btn-kovatek add-rounded px-5 py-2 mr-auto">Yes</button>
                        <button key="submit" @click="handleCancel" class="btn-outline-kovatek add-rounded px-5 py-2">No</button>
                    </div>
                    
                </template>
                <div class="font-weight-bolder">
                    <h4 class="kova-text text-center mt-4 mb-3">Are you sure you want to delete this Project?</h4>
                </div>
                </a-modal>
            </div>
            <div>
                <a-modal v-model="callScheduled" title="" onOk="handleOk" width="600px">
                <template slot="footer">
                    <a-button key="submit" style="background-color:#20409a; color: #fff" @click="callScheduledOk"> Ok </a-button>
                </template>
                    <div class="mt-4 p-4 bg-light"></div>
                </a-modal>
            </div>

            <a-modal v-model="openLinkModal" title="" onOk="handleOk" width="600px">
                <template slot="footer">
                    <a-button key="submit" style="background-color:#20409a; color: #fff" @click="addLink" class="px-4"> Add </a-button>
                </template>
                    <div class="mt-4 p-4">
                        <h6 class="">Paste link here</h6>
                        <a-input size="large" placeholder="Paste link here" v-model="newLink" />
                    </div>
                </a-modal>
        </div>
        <Footer />
    </div>
</template>

<script>

import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
// import Messages from '@/components/Messages.vue'
// import Notifications from '@/components/Notifications.vue'
import CurrentlyHired from '@/components/CurrentlyHired.vue'
import { computeStatus, computeDuration, computeCommitment, computeExperienceLevel } from '@/helpers/compute.js'
import { HollowDotsSpinner } from 'epic-spinners'
import axios from "axios";
import { uuid } from 'vue-uuid';

export default {
    name: 'hired',
    components: {
        Navbar, Footer, 
        // Messages, Notifications, 
        CurrentlyHired, HollowDotsSpinner
    },
    data(){
        return {
            
            workHistory: [
                {title: 'Adebayo Mary', duration: ' Mar 2016 - Sep 2018', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 963.34, earnedPerHour: 20.00, hours: 48, hireStatus: true, saved: false, readMore: false},
                {title: 'Adebayo Mary', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 560.00, earnedPerHour: 30.00, hours: 19, hireStatus: false, saved: false, readMore: false},
                {title: 'Adebayo Mary', duration: ' Mar 2016 - Sep 2018', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 963.34, earnedPerHour: 20.00, hours: 48, hireStatus: true, saved: true, readMore: false},
                {title: 'Adebayo Mary', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 560.00, earnedPerHour: 30.00, hours: 19, hireStatus: false, saved: false, readMore: false},
                {title: 'Adebayo Mary', duration: ' Mar 2016 - Sep 2018', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 963.34, earnedPerHour: 20.00, hours: 48, hireStatus: false, saved: true, readMore: false},
                {title: 'Adebayo Mary', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 560.00, earnedPerHour: 30.00, hours: 19, hireStatus: false, saved: false, readMore: false},
            ],
            proSkills: [
                'Database','Modeling', 'Vue.js' 
            ],
            skills: [
                'Laravel Framework', 'Nodejs','Golang','jQuery', 'JavaScript','database', 'Modeling','Vue.js','Express.js', 'Ext JS', 'Docker'
            ],
            loading: true,
            visible: false,
            callScheduled: false,
            otherDetails: true,
            showmore: false,
            mileStone: [
                {title: 'Login Setub', amount: 210},
                {title: 'API Integration', amount: 89},
                {title: 'Front - End', amount: 400},
                {title: 'Back - End', amount: 600},
                {title: 'Design sign up and user authentication package', amount: 50},
                
            ],
            specialization: ['Web Application', 'Front End', 'Blockchain', 'Integration'],
            dir: 'down',
            defaultFileList: [
                {
                    uid: '2',
                    name: 'yyy.png',
                    status: 'done',
                    url: 'http://www.baidu.com/yyy.png',

                },
                {
                    uid: '3',
                    name: 'zzz.png',
                    status: 'error',
                    response: 'Server Error 500', // custom error message to show
                    url: 'http://www.baidu.com/zzz.png',
                },
            ],
            linkList: [
                'https://kovatek.com'
            ],
            openLinkModal: false,
            newLink: '',
            readMore:false,
            hireVisible: false,
            paymentModalVisible: false,
            project: {},
            bidding: {
                talent_id: null,
                wages: null
            },
            error: '',
            response: "",
            applicants: [],
            wallet: null,
            paymentModalAmount: null,
            paymentModalCurrecncy: null,
            data: null,
            projectUsdBudget: null,
        }
    },
    methods: {
        mergeSkills(CoreTechstack, OtherCoreTechstacks) {
        const array = CoreTechstack.split(',');
        for (let i = 0; i < OtherCoreTechstacks.length; i++) {
            array.push(OtherCoreTechstacks[i]);
        }
        return array;
        },
      computeLevel(level) {
      return computeExperienceLevel(level);
      },
      makePaymentCallback(response) {
        try {
           const config = {
          headers: {
            "Content-type": "application/json"
          }
        };
        const body = JSON.stringify({ currency: response.currency, txRef: response.tx_ref, amount: response.amount });
         axios.defaults.withCredentials = true;
         axios.post("https://api.kovatek.com/payments/verify", body, config);
        /* console.log('final result: ' + JSON.stringify(result)); */

        this.$store.dispatch("biddings/postBidding", { projectId: this.$store.state.projects.projectId, bidding: this.bidding })
            .then(resp => {
               this.response = resp;
                this.hireVisible = false;
                this.visible = false;
                this.loading = false;
                this.$toast.fire({
                    icon: 'success',
                    title: 'Talent Hired Successfully!',
                });
            })
            .catch(err => {
              this.error = err
            })
          
        } catch (err) {
          /* console.log('final error: ' + err); */
          this.error  = err;
        }
    },
    closedPaymentModal() {
      /* console.log('payment modal is closed'); */
       this.$router.go();
    },
    generateReference(){
      return uuid.v4();
    },
        styleScroll: function(){
                let isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
                let isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
                let scrollbarDiv = document.querySelector('.scrollbar');
                if (!isChrome && !isSafari) {
                    scrollbarDiv.innerHTML = 'You need Webkit browser to run this code';
                }
        },
        goBack(){
            this.$router.go(-1)
        },
        showHire(talentid, wages){
            this.bidding.talent_id = talentid;
            this.bidding.wages = wages;
            this.hireVisible = true;
        },
        confirmHire(){
            if (this.project.Budget > this.wallet.LedgerBalance) {
                /* this.$router.push('settings') */
                //show paymentModal 
                this.hireVisible = false;
                this.paymentModalVisible = true;
            } else {
                this.$store.dispatch("biddings/postBidding", { projectId: this.$store.state.projects.projectId, bidding: this.bidding })
            .then(resp => {
               this.response = resp;
                this.hireVisible = false;
                this.visible = false;
                this.loading = false;
                this.$toast.fire({
                    icon: 'success',
                    title: 'Talent Hired Successfully!',
                });
                this.$router.go()
            })
            .catch(err => {
              this.error = err
              this.$toast.fire({
                    icon: 'error',
                    title: err.message,
                });
            })

            }
            
            
            // this.loading = true;
            // setTimeout(() => {

            // this.loading = false;
            // }, 1500);
        },
        cancelHire(){
            this.hireVisible = false;
        },
        showModal() {
            this.visible = true;
        },
        handleOk() {
            // this.loading = true;
            // setTimeout(() => {
            this.visible = false;
            // this.loading = false;
            // }, 1000);
        },
        handleCancel() {
            this.visible = false;   
        },
        showCallScheduled(){
            // this.loading = true;
            //     setTimeout(() => {
                this.visible = false;
                // this.loading = false;
                this.callScheduled = true;
                // }, 3000);
        },
        callScheduledOk(){
            this.callScheduled = false;
        },
        showOtherDetails(){
            this.otherDetails = !this.otherDetails
            this.showmore = false
        },
        showLessDetails(){
            this.otherDetails = !this.otherDetails
            this.showmore = true
        },
        upload() {
            //parameter { file, fileList }
            // if (file.status !== 'uploading') {
            // console.log(file, fileList);
            // }
        },
        openLink(){
            this.openLinkModal = true

        },
        addLink(){
            this.linkList.push(this.newLink)
            this.openLinkModal = false
        },
        paymentSummary(){
            this.$router.push('payment-summary')
        },
        hireForJob(){
            this.$router.push('hire-for-job');
        },
        message(){
            this.$router.push('chat');
        },
        devDetails(){
            this.$router.push('dev-details');
        },
        editJob(){
            this.$store.state.projects.title = this.project.Title
            this.$store.state.projects.description = this.project.Description
            this.$store.state.projects.talent_size = this.project.TalentSize
            this.$store.state.projects.duration = this.project.Duration
            this.$store.state.projects.complexity = this.project.Complexity
            this.$store.state.projects.start_budget = this.project.StartBudget
            this.$store.state.projects.end_budget = this.project.EndBudget
            this.$store.state.projects.skills = this.project.Skills

           
            this.$router.push(`onboarding-review?edit=true&projectId=${this.$store.state.projects.projectId}`)
        },
        updateProjectStatus(status){
            this.$store.dispatch("projects/updateProjectStatus", { projectId: this.$store.state.projects.projectId, status: status })
            .then(resp => {
               this.response = resp;
            })
            .catch(err => {
              this.error = err;
            })
        },
        deleteProject(){
            this.loading = true;
            this.$store.dispatch("projects/deleteProject", { projectId: this.$store.state.projects.projectId })
            .then(resp => {
               this.response = resp;
                this.visible = false;
                this.loading = false;
            })
            .catch(err => {
              this.error = err
            })
        }
    },
    computed: {

        projectStatus: function() { 
            return computeStatus(this.project.Status)
            },
        projectDuration: function() { 
            return computeDuration(this.project.Duration) 
            },
        projectCommitment: function() { 
            return computeCommitment(this.project.Commitment) 
            }

    },
    mounted(){

        this.$store.dispatch("settings/userSettings")
      .then(resp => {
         /* console.log(resp) */
        // this.response = { ...resp.data }
        this.data = { ... resp.data }
        // console.log({ ...resp.data } )
      })
      .catch(err => {
        this.message = err;
        // console.log(err.message, err.response)
      })
        
        this.$store.state.projects.projectId = this.$route.query.projectId;
         this.$store.dispatch("profiles/getWallet").then( resp => {
                this.wallet = { ...resp.data }
                /* console.log(resp) */
         }).catch( err => {
               /* console.log(err.message) */
                this.error = err.message
                this.loading = false
            })

        this.$store.dispatch("projects/getProject", {projectId: this.$store.state.projects.projectId })
            .then( resp => {
                this.project = { ...resp.data }
                this.$store.dispatch("biddings/getBidding", {projectId: this.$store.state.projects.projectId })
                    .then(res => {
                      this.applicants = res.data;
                        this.loading = false        
                    })
                    .catch( err => {
                        
                        this.error = err.message
                        this.loading = false
                    })
               
            })
            .catch( err => {
               
                this.error = err.message
                this.loading = false
            })
    }
}
</script>
<style scoped>
.browse-list{
    width: 80%;
}
.sort-by{
    position: relative;
    top:33px;
}
.icon-size{
    font-size: 25px;
}
.icon-size1{
    font-size: 20px;
}
.img-height{
    width: 90px;
    height: 90px;
}
.img-height-2{
    width: 130px;
    height: 130px;
}
.icon-env{
    font-size: 20px;
}
.ctrl-size{
    font-size: 10px;
}
.ctrl-size-1{
    font-size: 20px
}
.ctrl-size-2{
    font-size: 11px;
}
.ctrl-size-3{
    font-size: 9px;
}
.ctrl-size-4{
    font-size: 14px;
}
.ctrl-size-5{
    font-size: 12px;
}
.latest{
    color: #2db7f5;
}
.jobs-post{
    height: 400px;
    overflow-y: scroll;
}
.new-project{
    width: 260px;
}
.add-new{
    color: #20409a;
}
.add-new:hover{
    color:#0c2b80
}
.bg-skills{
    background-color: #4BB38E;
    color: #fff;
}
.text-senior{
    color: #BD6377;
}
.text-intermediate{
    color: #BDBD50;
}
.btn-rounded{
    border-radius: 30px;
}
.bookmark{
    font-size: 24px;
}
.btn-hired{
    outline: 0;
    border: 0;
    color: #fff;
    background-color: #FE9816;
    border-radius: 30px;
    cursor: pointer;
    transition: .25s;
}
.btn-hired:hover{
    color: #fff;
    background-color: #eb9627;
}
[data-toggle="collapse"] .fas:before {  
  content: "\f055";
}

[aria-expanded="true"] .fas:before {  
  content: "\f056";
}

[data-toggle="collapse"].collapsed .fas:before {
  content: "\f055";
}
.ctrl-ellipsis{
    font-size: 20px;
}
.modal-text{
    font-size: 30px;
}
@media screen and (min-width: 992px) and (max-width: 1325px){
  .new-project{
        width: 300px;
    }  
}

@media screen and (min-width: 992px) and (max-width: 1200px){
    .img-height{
        width: 60px;
        height: 60px;
    }
    .new-project{
        width: 260px;
    } 
}

@media screen and (min-width: 768px) and (max-width: 991px){
   .hired-width{
       width: 500px;
   }
   .notifications-width{
       width: 600px
   }
}

@media screen and (max-width: 767px){
    .float-text{
        display: flex;
        justify-content: space-around;
        padding-left: 20px;
    }
    .float-text h6{
        float: left;
    }
    .hired-width{
       width: 85%;
   }
    .notifications-width{
       width: 90%
   }
}

@media screen and (max-width: 550px){
    .ctrl-search{
        width: 55%;
    }
    .img-height{
        width: 65px;
        height: 65px;
    }
    .img-height-2{
        width: 85px;
        height: 85px;
    }
    .hired-width{
       width: 95%;
   }
   .notifications-width{
       width: 98%
   }
   .change-size{
       font-size: 12px;
   }
   .modal-name{
        font-size: 15px;
    }
}
</style>